module.exports = __webpack_public_path__ + "static/img/img_empty_limit_def.27825998.svg";